import React from "react";
import { Toaster } from "react-hot-toast";
import MyRouter from "routers/index";

function App() {
  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
        <Toaster
          position="top-center"
          reverseOrder={false}
        />
        <MyRouter />
    </div>
  );
}

export default App;
